export const DICTIONARY_API =
  "https://api.dictionaryapi.dev/api/v2/entries/en/";
